export const REFRESH_THRESHOLD_SECONDS = 60
export const MAX_REFRESH_RETRIES = 3
export const BASE_BACKOFF_MS = 1000
